import React from 'react';
import { useIntl } from 'react-intl';

import { Table } from '~/eds/src/modules/Table/Table';

import { ClauseType } from './types';

interface Props {
  clauseTypes: ClauseType[];
  isLoading?: boolean;
}

export const Top3ClauseTypes = ({ clauseTypes = [], isLoading }: Props) => {
  const intl = useIntl();

  if (!clauseTypes.length) return null;

  const top3ClauseTypes = sortByCount(clauseTypes).slice(0, 3);
  const columns = [
    {
      key: 'name',
      title: intl.formatMessage({
        id: 'Top3ClauseTypes.clauseTypeColumn',
        defaultMessage: 'Clause Type',
        description: 'Column header for clause type names',
      }),
      cellType: 'text',
      mapCellProps: (clauseType: ClauseType) => ({ text: clauseType.name }),
    },
    {
      key: 'count',
      title: intl.formatMessage({
        id: 'Top3ClauseTypes.countColumn',
        defaultMessage: 'Count',
        description: 'Column header for clause type counts',
      }),
      cellType: 'text',
      mapCellProps: (clauseType: ClauseType) => ({
        text: intl.formatMessage(
          {
            id: 'Top3ClauseTypes.matchesCount',
            defaultMessage: '{count} matches',
            description:
              'Display count of matches for clause type. Example: count = 45',
          },
          { count: clauseType.count },
        ),
      }),
    },
  ];

  return (
    <Table
      name="top 3 clause types"
      isLoading={isLoading}
      mode="summary"
      header={{
        title: intl.formatMessage({
          id: 'Top3ClauseTypes.tableTitle',
          defaultMessage: 'Clause Types Found in Your Contracts',
          description: 'Table header title for top clause types',
        }),
        chips: [
          {
            text: intl.formatMessage({
              id: 'Top3ClauseTypes.poweredByChip',
              defaultMessage: 'Powered by Evisort AI',
              description: 'Chip text indicating AI-powered feature',
            }),
            preset: 'ai',
          },
        ],
      }}
      columns={columns}
      data={top3ClauseTypes}
    />
  );
};

export const sortByCount = (clauseTypes: ClauseType[]): ClauseType[] => {
  return clauseTypes.sort((a, b) => (b?.count ?? 0) - (a?.count ?? 0));
};
